import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";

export const ProtectedRoute = ({ children }) => {
  const adminToken = window.localStorage.getItem("UserRetention");
  const siteURL = window.localStorage.getItem("siteURL");

  if (
    adminToken == null ||
    adminToken == "null" 
  ) {
    return <Navigate to="/login" />;
  }

  return children;
};

export const ProtectedAuthRoute = ({ children }) => {
  const adminToken = window.localStorage.getItem("UserRetention");

  return !adminToken ? children : <Navigate to="/" />;
};
